/* global G */
import { curry } from 'lib/util'
import { actionWithHooks } from 'lib/sequence/module/action'
import routeComposition from '@gaia/trait/composition/route'

/**
 * Submit Event Handler
 *
 * It executes module action submit() by "Fire-N-Forget"
 *
 * @param {Gaia.AppModule.Spec} module          app module
 * @param {Gaia.Component.Spec} component       action component
 * @param {Gaia.AppModule.EventHandler} event   event
 * @param {string} [action]                     specific action to execute on module
 * @returns {Promise<void>} void
 */
const submit = async (module, component, event, action = 'submit') => {
  event.preventDefault()
  event.stopPropagation()

  const moduleState = module[G.STATE]
  const currentRoute = moduleState[G.ROUTE]

  try {
    const { route } = component[G.CONFIGURATION]

    if (!route) {
      throw ReferenceError(`no route defined in component configuration ${component._name}`)
    }

    moduleState[G.ROUTE] = routeComposition(route.module, route.action)

    await actionWithHooks(module[G.ACTIONS][action])()
  } catch (e) {
    console.error(e)
    moduleState[G.ROUTE] = currentRoute
  }
}

export default curry(submit)
